import React from 'react'
import { toast } from 'react-toastify'

import { isDesktop } from 'utils/device'

import GeneralNotifications from './notifications'

export const generalNotifications = (() => {
    const toastOptions = {
        position: isDesktop ? 'bottom-left' : 'bottom-center',
        autoClose: false,
        closeOnClick: false,
    }

    const notifyLowBandwidth = ({ title, subtitle }) => {
        const props = {
            icon: {
                src: 'assets/revamp/notifications/network-poor.svg',
                alt: 'bad-network',
            },
            title: title || 'Can’t see others on this call?',
            subtitle:
                subtitle ||
                'Your internet connection seems weak. We’ve turned off other videos for a better experience.',
        }
        return toast.success(<GeneralNotifications {...props} />, toastOptions)
    }

    const notifyVideoTrackError = () => {
        const props = {
            icon: {
                src: 'assets/revamp/notifications/video.svg',
                alt: 'bad-network',
            },
            title:
                'There was a problem detecting your camera. Restart your browser or device and try again.',
            subtitle: '',
        }
        return toast.success(<GeneralNotifications {...props} />, toastOptions)
    }

    return {
        notifyLowBandwidth,
        notifyVideoTrackError,
    }
})()
